/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Content_RemovedInputs */



/**
* | output |
* | --- |
* | "Content at this position will be removed" |
*
* @param {Suggestions_Content_RemovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_content_removed = /** @type {((inputs?: Suggestions_Content_RemovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Content_RemovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalt an dieser Stelle wird entfernt")
	return /** @type {LocalizedString} */ ("Content at this position will be removed")
});